import { useMemo } from 'react';
import { Link } from 'react-router';

import { HoverCardWithIcon } from '@/common/components/shared/hover-card/HoverCardWithIcon';
import type { ContractType } from '@/common/graphql';
import type { UseContractTypePersistenceReturn } from '@/common/hooks/employees/useContractTypePersistence';

interface HintGoogleWorkspacePlanProps {
  allContractTypes: UseContractTypePersistenceReturn['data'];
  contractType: ContractType | null;
}

export const HintGoogleWorkspacePlan = ({ contractType, allContractTypes }: HintGoogleWorkspacePlanProps) => {
  const plan = useMemo(
    () => allContractTypes?.find(it => it.value === contractType)?.defaultGoogleWorkspacePlan ?? null,
    [allContractTypes, contractType],
  );

  if (!allContractTypes || !plan) {
    return <></>;
  }

  return (
    <div className="inline-flex items-center gap-1">
      <div>
        <span className="text-gray-7">Google Workspace Plan:&nbsp;</span>
        <span className="text-gray-9">{plan}</span>
      </div>
      <TooltipContractType />
    </div>
  );
};

const TooltipContractType = () => (
  <HoverCardWithIcon defaultOpened={true} position="bottom">
    <span className="font-semibold">Business Starter</span>
    &nbsp;plan is for interns and temporary staff - same features as&nbsp;
    <span className="font-semibold">Enterprise Standard</span>
    &nbsp;but with lower cost and less storage.
    <br />
    You can change the plan from&nbsp;
    <Link className="!text-blue-4" target="_blank" to="https://admin.google.com">
      Google Admin Console
    </Link>
    &nbsp;after creating an employee.
  </HoverCardWithIcon>
);
